import { get } from '..';

// eslint-disable-next-line no-shadow
export enum UserSortCategory {
  // eslint-disable-next-line no-unused-vars
  FIRST_NAME = 'firstName', LAST_NAME = 'lastName', EMAIL = 'email',
}
interface GetUsersProps {
  userGroupId?: string,
  roleId?: string,
  name?: string,
  email?: string,
  sortBy?: UserSortCategory,
  sortDescending?: boolean,
}

const getUsers = (params: GetUsersProps = {}) => {
  let url: string = 'users/v2';

  Object.keys(params).forEach((key: string, index: number) => {
    if (!params[key]) return;
    url += `${index === 0 ? '?' : '&'}${key}=${encodeURIComponent(params[key])}`;
  });

  return get(url);
};

export default getUsers;
